import { create } from 'zustand'
import { getCartItemCount } from '@/lib/cart'

interface CartState {
  itemCount: number
  loading: boolean
  incrementCount: (quantity: number) => void
  decrementCount: (quantity: number) => void
  setCount: (count: number) => void
  refreshCount: () => Promise<void>
}

export const useCartStore = create<CartState>((set) => ({
  itemCount: 0,
  loading: false,

  incrementCount: (quantity: number) => {
    set((state) => ({
      itemCount: state.itemCount + quantity,
    }))
  },

  decrementCount: (quantity: number) => {
    set((state) => ({
      itemCount: Math.max(0, state.itemCount - quantity),
    }))
  },

  setCount: (count: number) => {
    set({ itemCount: Math.max(0, count) })
  },

  refreshCount: async () => {
    try {
      set({ loading: true })
      const count = await getCartItemCount()
      set({ itemCount: count })
    } catch (error) {
      console.error('Failed to fetch cart count:', error)
      set({ itemCount: 0 })
    } finally {
      set({ loading: false })
    }
  },
}))
